import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { isNil, isNumber } from 'lodash';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { filter, take } from 'rxjs/operators';
import { ISwipeResponse } from '../../../typings/api';
import { IUser } from '../../../typings/timetracker/timetracker';
import { UserSelectorComponent } from '../../components/user-selector/user-selector';
import { WeekSelectorComponent } from '../../components/week-selector/week-selector';
import { EmployeeAutoCompleteService } from '../../providers/employee-auto-complete';
import { UserService } from '../../providers/user.service';
import { TimesheetService } from '../timesheets/providers/timesheet.service';

/**
 * Generated class for the SwipesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-swipes',
  templateUrl: 'swipes.html',
  providers: [ EmployeeAutoCompleteService ]
})
export class SwipesPage implements OnInit {

  @ViewChild( 'userSelector' ) userSelector: UserSelectorComponent;
  @ViewChild( 'weekSelector' ) weekSelector: WeekSelectorComponent;

  currentWeekNumber: number
  currentYear: number;
  currentUser: IUser;
  swipes$: Observable<ISwipeResponse[]> = this.$userService.selectUserListSwipes();

  public selectUser( user: IUser ) {
    this.currentUser = user;
    console.log( '[SWIPES] Change user', user );
    this.updateList();
  }

  /**
   * @param {number} userId The user ID to retrieve the details for
   */
  public getUserDetails( userId: number ): Observable<IUser> {
    return this.$userService.selectUserByIdFetch( userId );
  }

  public selectDate( date: Date ) {
    console.log( '[SWIPES] Change date', date );
    const thisMoment = moment( date );
    this.currentWeekNumber = thisMoment.isoWeek();
    this.currentYear = thisMoment.isoWeekYear();
    this.updateList();
  }

  updateList() {
    if ( this.currentUser && isNumber( this.currentWeekNumber ) && isNumber( this.currentYear ) ) {
      this.$userService.dispatchUserListSwipes( this.currentUser.id, this.currentWeekNumber, this.currentYear );
    }
  }

  ngOnInit(): void {
    const localStorageData = this.$timesheetService.getStoredTimesheetData();

    // Determine selected week and year
    //
    if ( localStorageData.isoWeek && localStorageData.year )
    {
      this.currentWeekNumber = localStorageData.isoWeek;
      this.currentYear = localStorageData.year;
    } else
    {
      const now = moment();
      this.currentWeekNumber = now.isoWeek();
      this.currentYear = now.isoWeekYear();
    }

    // Update week selector
    //
    this.weekSelector.setWeek( this.currentWeekNumber, this.currentYear );

    if ( localStorageData.userId ) {
      this.getUserDetails( localStorageData.userId ).pipe(
        filter( ( value ) => !isNil( value ) ),
        take( 1 )
      ).subscribe( ( userDetails ) => {
        this.currentUser = userDetails;
        this.updateList();
      } );
    }
  }

  constructor(
    private $userService: UserService,
    private $timesheetService: TimesheetService ) {}
}



// WEBPACK FOOTER //
// ./src/pages/swipes/swipes.ts